import React from 'react';
import PropTypes from 'prop-types';
import { HelixIcon } from '@lwt-helix/helix-icon';
import { add } from '@lwt-helix/helix-icon/solid';
import { sparkle } from '@lwt-helix/helix-icon/outlined';
import { LikelihoodChart } from './LikelihoodChart';
import { getCurrencyFormat } from '../../../helpers/dataFormatters';
import { agentProductionTerms } from '../../../../constants/index';
import { todaysPicksTerms } from '../../../constants/suggestedAgents'

export const TodaysPicksCard = ({ agent }) => {
    const fullName = `${agent.firstName} ${agent.lastName}`;
    const projectedRange = todaysPicksTerms.projectedRange(agent.projectedVolumeMin, agent.projectedVolumeMax)
    const projectedUnitsRange = todaysPicksTerms.projectedUnitsRange(agent.projectedUnitsMin, agent.projectedUnitsMax)
    const volumeFormatted = `${getCurrencyFormat(agent.volume)}`

    return (
        <div className="helix-card helix-h-100-percent helix-overflow--hidden helix-position--relative p-2">
            <button 
                className="todays-picks-add-btn"
                type="button"
            >
                <HelixIcon icon={add} />
            </button>

            <div className="helix-d-flex helix-flex--column helix-gap-3 helix-p-3">
                <div className="helix-d-flex helix-flex--column mb-2">
                    <div 
                        className="helix-text-gray-900 helix-line-clamp-1 todays-picks-agent-name"
                    >
                        {fullName}
                    </div>
                    <div 
                        className="helix-text-gray-500 helix-line-clamp-1 helix-text--hint helix-small" 
                    >
                        {agent.officeName}
                    </div>
                </div>

                <LikelihoodChart likelihood={agent.likelihoodOfMovement} />

                <div className="helix-d-flex mt-2">
                    <div className="helix-d-flex helix-flex--column helix-align--center todays-picks-stat-col">
                        <div className="helix-text-gray-500 todays-picks-label">
                            {todaysPicksTerms.volume}
                        </div>
                        <div className="helix-text-gray-900 todays-picks-value">
                            {volumeFormatted}
                        </div>
                    </div>
                    <div className="helix-d-flex helix-flex--column helix-align--center todays-picks-stat-col">
                        <div className="helix-text-gray-500 todays-picks-label">
                            {todaysPicksTerms.units}
                        </div>
                        <div className="helix-text-gray-900 todays-picks-value">
                            {agent.units ?? agentProductionTerms.notApplicableAbbrv}
                        </div>
                    </div>
                </div>
                <div className="todays-picks-divider" />
                <div className="helix-d-flex helix-justify--center helix-text-gray-500 todays-picks-label">
                    {todaysPicksTerms.eoyPerformanceProjections}
                </div>
                <div className="helix-d-flex">
                    <div className="helix-d-flex helix-flex--column helix-align--center todays-picks-stat-col">
                        <span className="helix-badge helix-badge--secondary-inverted helix-small">
                            <HelixIcon icon={sparkle} className="helix-svg-fill--brand" />
                            {projectedRange}
                        </span>
                    </div>
                    <div className="helix-d-flex helix-flex--column helix-align--center todays-picks-stat-col">
                        <span className="helix-badge helix-badge--secondary-inverted helix-small">
                            <HelixIcon icon={sparkle} className="helix-svg-fill--brand"/>
                            {projectedUnitsRange}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

TodaysPicksCard.propTypes = {
    agent: PropTypes.object
};

export default TodaysPicksCard;
